import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import { Row, Col, Space, Button } from "antd";
import { LogoutOutlined, MenuOutlined } from "@ant-design/icons";

import { logout, storeMe } from "./../app.slice";

import { useFetchMeQuery } from "./../pages/home/home.service";
import { useGetTimezoneQuery } from "../pages/settings/settings.service";
import moment from "moment/moment";
import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import { useTimezone } from "../provider/timezoneprovider";

function Header({ name, subName, onPress }) {
  const dispatch = useDispatch();
  const [curDate, setCurDate] = useState(new Date());
  const { timezone: globalTimezone, setTimezone } = useTimezone();

  const { data: timezoneData } = useGetTimezoneQuery();

  useEffect(() => {
    if (timezoneData?.timezone) {
      setTimezone(timezoneData.timezone);
    }
  }, [timezoneData, setTimezone]);

  useEffect(() => {
    const interval = setInterval(() => setCurDate(new Date()), 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const {
    data: user,
    isError,
    isSuccess,
  } = useFetchMeQuery(undefined, {
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (isSuccess) dispatch(storeMe(user?.user));
  }, [isSuccess, user]);

  useEffect(() => {
    if (isError) {
      dispatch(logout());
    }
  }, [isError]);

  const items = [
    {
      key: "1",
      label: (
        <Space onClick={() => dispatch(logout())}>
          <LogoutOutlined />
          <span>Logout</span>
        </Space>
      ),
    },
  ];

  return (
    <>
      <Row gutter={[24, 0]}>
        <Col span={12} md={6}>
          <Button
            type="primary"
            size="large"
            className="header-sidebar-control"
            onClick={onPress}
            icon={<MenuOutlined />}
          ></Button>
        </Col>

        <Col span={12} md={18} className="header-control">
          <div style={{ fontSize: "15px", fontWeight: "bold" }}>
            {curDate.toLocaleString("en-US", {
              timeZone: globalTimezone,
              timeZoneName: "short",
            })}
          </div>
        </Col>
      </Row>
    </>
  );
}

export default Header;
